export const apiUrl = process.env.API_URL || "https://piction-ai.herokuapp.com";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
